
export class PlatformPatterns {
  static readonly PLATFORM_PATTERNS = {
    amazon: [
      /amazon\.(com|co\.uk|de|fr|es|it|ca|com\.au)/i,
      /amzn\.to/i,
      /a\.co/i,
      /amazon marketplace/i,
      /fulfilled by amazon/i,
      /fba/i,
      /^amazon$/i,  // Match exact "amazon"
      /amazon\s+(store|seller|purchase|order)/i,
      /amazon\.com/i,
      /\bamazon\b/i,  // Match "amazon" as a whole word
      /amazon\s*store/i,
      /amazon\s*purchase/i,
      /amazon\s*order/i,
      /amazon\s*refund/i,
      /bought.*amazon/i,
      /purchased.*amazon/i,
      /order.*amazon/i,
      /from.*amazon/i
    ],
    walmart: [
      /walmart\.(com|ca)/i,
      /\bwalmart\b/i,
      /walmart\s*(store|purchase|order|refund)/i,
      /bought.*walmart/i,
      /purchased.*walmart/i,
      /order.*walmart/i,
      /from.*walmart/i,
      /walmart\.com/i,
      /^walmart$/i
    ],
    target: [
      /target\.(com|ca)/i,
      /\btarget\b/i,
      /target\s*(store|purchase|order|refund)/i,
      /bought.*target/i,
      /purchased.*target/i,
      /order.*target/i,
      /from.*target/i,
      /target\.com/i,
      /^target$/i
    ],
    bestbuy: [
      /bestbuy\.(com|ca)/i,
      /best\s*buy/i,
      /\bbestbuy\b/i,
      /best\s*buy\s*(store|purchase|order|refund)/i,
      /bought.*best\s*buy/i,
      /purchased.*best\s*buy/i,
      /order.*best\s*buy/i,
      /from.*best\s*buy/i,
      /bestbuy\.com/i
    ],
    wayfair: [
      /wayfair\.(com|ca|co\.uk)/i,
      /\bwayfair\b/i,
      /wayfair\s*(store|purchase|order|refund)/i,
      /bought.*wayfair/i,
      /purchased.*wayfair/i,
      /order.*wayfair/i,
      /from.*wayfair/i,
      /wayfair\.com/i,
      /^wayfair$/i
    ],
    newegg: [
      /newegg\.(com|ca)/i,
      /\bnewegg\b/i,
      /newegg\s*(store|purchase|order|refund)/i,
      /bought.*newegg/i,
      /purchased.*newegg/i,
      /order.*newegg/i,
      /from.*newegg/i,
      /newegg\.com/i,
      /^newegg$/i
    ],
    macys: [
      /macys\.(com|ca)/i,
      /macy\'s/i,
      /\bmacys\b/i,
      /\bmacy\'s\b/i,
      /macys?\s*(store|purchase|order|refund)/i,
      /bought.*macys?/i,
      /purchased.*macys?/i,
      /order.*macys?/i,
      /from.*macys?/i,
      /macys\.com/i
    ],
    nordstrom: [
      /nordstrom\.(com|ca)/i,
      /\bnordstrom\b/i,
      /nordstrom\s*(store|purchase|order|refund)/i,
      /bought.*nordstrom/i,
      /purchased.*nordstrom/i,
      /order.*nordstrom/i,
      /from.*nordstrom/i,
      /nordstrom\.com/i,
      /^nordstrom$/i
    ],
    kohls: [
      /kohls\.(com|ca)/i,
      /kohl\'s/i,
      /\bkohls\b/i,
      /\bkohl\'s\b/i,
      /kohls?\s*(store|purchase|order|refund)/i,
      /bought.*kohls?/i,
      /purchased.*kohls?/i,
      /order.*kohls?/i,
      /from.*kohls?/i,
      /kohls\.com/i
    ],
    homedepot: [
      /homedepot\.(com|ca)/i,
      /home\s*depot/i,
      /\bhomedepot\b/i,
      /home\s*depot\s*(store|purchase|order|refund)/i,
      /bought.*home\s*depot/i,
      /purchased.*home\s*depot/i,
      /order.*home\s*depot/i,
      /from.*home\s*depot/i,
      /homedepot\.com/i
    ],
    lowes: [
      /lowes\.(com|ca)/i,
      /lowe\'s/i,
      /\blowes\b/i,
      /\blowe\'s\b/i,
      /lowes?\s*(store|purchase|order|refund)/i,
      /bought.*lowes?/i,
      /purchased.*lowes?/i,
      /order.*lowes?/i,
      /from.*lowes?/i,
      /lowes\.com/i
    ],
    costco: [
      /costco\.(com|ca)/i,
      /\bcostco\b/i,
      /costco\s*(store|purchase|order|refund)/i,
      /bought.*costco/i,
      /purchased.*costco/i,
      /order.*costco/i,
      /from.*costco/i,
      /costco\.com/i,
      /^costco$/i
    ],
    apple: [
      /apple\.(com|ca)/i,
      /\bapple\b/i,
      /apple\s*(store|purchase|order|refund)/i,
      /bought.*apple/i,
      /purchased.*apple/i,
      /order.*apple/i,
      /from.*apple/i,
      /apple\.com/i,
      /^apple$/i,
      /apple\s*store/i
    ],
    dell: [
      /dell\.(com|ca)/i,
      /\bdell\b/i,
      /dell\s*(store|purchase|order|refund)/i,
      /bought.*dell/i,
      /purchased.*dell/i,
      /order.*dell/i,
      /from.*dell/i,
      /dell\.com/i,
      /^dell$/i
    ],
    nike: [
      /nike\.(com|ca)/i,
      /\bnike\b/i,
      /nike\s*(store|purchase|order|refund)/i,
      /bought.*nike/i,
      /purchased.*nike/i,
      /order.*nike/i,
      /from.*nike/i,
      /nike\.com/i,
      /^nike$/i
    ],
    adidas: [
      /adidas\.(com|ca)/i,
      /\badidas\b/i,
      /adidas\s*(store|purchase|order|refund)/i,
      /bought.*adidas/i,
      /purchased.*adidas/i,
      /order.*adidas/i,
      /from.*adidas/i,
      /adidas\.com/i,
      /^adidas$/i
    ],
    sephora: [
      /sephora\.(com|ca)/i,
      /\bsephora\b/i,
      /sephora\s*(store|purchase|order|refund)/i,
      /bought.*sephora/i,
      /purchased.*sephora/i,
      /order.*sephora/i,
      /from.*sephora/i,
      /sephora\.com/i,
      /^sephora$/i
    ],
    ulta: [
      /ulta\.(com|ca)/i,
      /ulta\s*beauty/i,
      /\bulta\b/i,
      /ulta\s*(store|purchase|order|refund)/i,
      /bought.*ulta/i,
      /purchased.*ulta/i,
      /order.*ulta/i,
      /from.*ulta/i,
      /ulta\.com/i,
      /^ulta$/i
    ],
    ebay: [
      // Enhanced eBay detection patterns
      /ebay\.(com|co\.uk|de|fr|es|it|ca|com\.au)/i,
      /\bebay\b/i,
      /^ebay$/i,
      /ebay\.com/i,
      /ebay\s*(seller|store|purchase|order|refund|auction|listing)/i,
      /bought.*ebay/i,
      /purchased.*ebay/i,
      /order.*ebay/i,
      /from.*ebay/i,
      /ebay\s*listing/i,
      /ebay\s*auction/i,
      /ebay\s*item/i,
      /ebay\s*store/i,
      /ebay\s*marketplace/i,
      /via\s*ebay/i,
      /through\s*ebay/i,
      /on\s*ebay/i,
      /ebay\s*seller/i,
      /ebay\s*transaction/i,
      /ebay\s*payment/i,
      /ebay\s*dispute/i,
      /ebay\s*case/i,
      /ebay\s*return/i,
      /ebay\s*refund/i
    ],
    etsy: [
      // Enhanced Etsy detection patterns
      /etsy\.(com|co\.uk|ca|de|fr)/i,
      /\betsy\b/i,
      /^etsy$/i,
      /etsy\.com/i,
      /etsy\s*(seller|shop|store|purchase|order|refund|listing)/i,
      /bought.*etsy/i,
      /purchased.*etsy/i,
      /order.*etsy/i,
      /from.*etsy/i,
      /etsy\s*shop/i,
      /etsy\s*store/i,
      /etsy\s*seller/i,
      /etsy\s*listing/i,
      /etsy\s*item/i,
      /etsy\s*marketplace/i,
      /via\s*etsy/i,
      /through\s*etsy/i,
      /on\s*etsy/i,
      /etsy\s*transaction/i,
      /etsy\s*payment/i,
      /etsy\s*dispute/i,
      /etsy\s*case/i,
      /etsy\s*return/i,
      /etsy\s*refund/i,
      /handmade.*etsy/i,
      /custom.*etsy/i,
      /artisan.*etsy/i,
      /craft.*etsy/i,
      /vintage.*etsy/i
    ],
    shopify: [
      /\.myshopify\.com/i,
      /shopify/i,
      /powered by shopify/i,
      /shopify store/i
    ],
    paypal: [
      /paypal\.com/i,
      /paypal\.me/i,
      /paypal payment/i,
      /paid via paypal/i,
      /paypal transaction/i
    ],
    facebook_marketplace: [
      /facebook marketplace/i,
      /fb marketplace/i,
      /marketplace\.facebook/i,
      /facebook\.com\/marketplace/i
    ],
    offerup: [
      /offerup/i,
      /offer up/i,
      /offerup\.com/i
    ],
    craigslist: [
      /craigslist/i,
      /craigslist\.org/i,
      /\.craigslist\./i
    ],
    mercari: [
      /mercari/i,
      /mercari\.com/i
    ],
    poshmark: [
      /poshmark/i,
      /poshmark\.com/i
    ],
    depop: [
      /depop/i,
      /depop\.com/i
    ],
    nextdoor: [
      /nextdoor finds/i,
      /nextdoor\.com\/finds/i,
      /nextdoor/i
    ],
    varagesale: [
      /varagesale/i,
      /varage sale/i,
      /varagesale\.com/i
    ],
    vinted: [
      /vinted/i,
      /vinted\.com/i
    ],
    reverb: [
      /reverb/i,
      /reverb\.com/i
    ],
    kidizen: [
      /kidizen/i,
      /kidizen\.com/i
    ],
    tradesy: [
      /tradesy/i,
      /tradesy\.com/i
    ],
    chairish: [
      /chairish/i,
      /chairish\.com/i
    ],
    fivemiles: [
      /5miles/i,
      /five miles/i,
      /5miles\.com/i
    ],
    gunbroker: [
      /gunbroker/i,
      /gun broker/i,
      /gunbroker\.com/i
    ],
    grailed: [
      /grailed/i,
      /grailed\.com/i
    ],
    // Subscription Platforms
    apple_app_store: [
      /app\s*store/i,
      /itunes/i,
      /charged\s*by\s*apple/i,
      /apple\s*app\s*store/i,
      /apple\.com\/bill/i,
      /reportaproblem\.apple/i,
      /apple\s*subscription/i,
      /apple\s*billing/i,
      /itunes\s*store/i,
      /apple\s*id\s*billing/i
    ],
    google_play: [
      /google\s*play/i,
      /play\s*store/i,
      /android\s*app/i,
      /play\.google\.com/i,
      /google\s*play\s*billing/i,
      /charged\s*by\s*google/i,
      /google\s*subscription/i,
      /play\s*store\s*refund/i
    ],
    netflix: [
      /netflix/i,
      /netflix\.com/i,
      /streaming\s*service/i,
      /billed\s*netflix/i,
      /charged\s*unexpectedly.*netflix/i,
      /cancel\s*netflix/i,
      /netflix\s*subscription/i,
      /netflix\s*billing/i
    ],
    spotify: [
      /spotify/i,
      /spotify\.com/i,
      /music\s*subscription/i,
      /spotify\s*charge/i,
      /spotify\s*premium/i,
      /cancel\s*spotify/i,
      /spotify\s*billing/i,
      /charged.*spotify/i
    ],
    youtube_premium: [
      /youtube\s*premium/i,
      /youtube\s*music/i,
      /youtube\s*charge/i,
      /refund.*premium/i,
      /cancel\s*youtube\s*premium/i,
      /youtube\s*subscription/i,
      /youtube\s*billing/i
    ],
    adobe_creative_cloud: [
      /adobe/i,
      /creative\s*cloud/i,
      /photoshop/i,
      /illustrator/i,
      /cancel\s*adobe/i,
      /charged\s*by\s*adobe/i,
      /adobe\s*subscription/i,
      /adobe\s*billing/i
    ],
    canva_pro: [
      /canva/i,
      /canva\s*pro/i,
      /charged\s*for\s*canva/i,
      /forgot.*cancel\s*canva/i,
      /canva\s*subscription/i,
      /canva\s*billing/i
    ],
    notion: [
      /notion/i,
      /notion\.so/i,
      /refund\s*notion/i,
      /accidental\s*notion\s*charge/i,
      /notion\s*subscription/i,
      /notion\s*billing/i
    ],
    grammarly: [
      /grammarly/i,
      /grammarly\s*premium/i,
      /refund\s*grammarly/i,
      /charged\s*by\s*grammarly/i,
      /grammarly\s*subscription/i,
      /grammarly\s*billing/i
    ],
    squarespace: [
      /squarespace/i,
      /charged\s*by\s*squarespace/i,
      /cancel\s*squarespace/i,
      /refund\s*domain/i,
      /squarespace\s*subscription/i,
      /squarespace\s*billing/i
    ],
    nordvpn: [
      /nordvpn/i,
      /vpn\s*refund/i,
      /cancel\s*nordvpn/i,
      /refund\s*vpn/i,
      /nordvpn\s*subscription/i,
      /nordvpn\s*billing/i
    ],
    expressvpn: [
      /expressvpn/i,
      /refund\s*expressvpn/i,
      /cancel\s*vpn/i,
      /express\s*vpn/i,
      /expressvpn\s*subscription/i,
      /expressvpn\s*billing/i
    ],
    upwork: [
      /upwork/i,
      /milestone/i,
      /freelancer.*upwork/i,
      /upwork.*freelancer/i
    ],
    fiverr: [
      /fiverr/i,
      /gig.*fiverr/i,
      /seller.*fiverr/i,
      /order.*fiverr/i
    ],
    freelancer: [
      /freelancer\.com/i,
      /freelancer/i,
      /project.*freelancer/i
    ],
    peopleperhour: [
      /peopleperhour/i,
      /pph/i,
      /invoice.*pph/i
    ],
    taskrabbit: [
      /taskrabbit/i,
      /tasker/i,
      /task.*rabbit/i
    ],

    // Event & Ticketing platforms
    ticketmaster: [
      /ticketmaster/i,
      /ticketmaster\.com/i,
      /live\s*nation/i,
      /livenation/i,
      /concert\s*ticket/i,
      /event\s*ticket/i,
      /venue\s*ticket/i,
      /tm\s*ticket/i
    ],

    stubhub: [
      /stubhub/i,
      /stubhub\.com/i,
      /stub\s*hub/i,
      /resale\s*ticket/i,
      /sports\s*ticket/i,
      /fanprotect/i,
      /fan\s*protect/i
    ],

    eventbrite: [
      /eventbrite/i,
      /eventbrite\.com/i,
      /event\s*brite/i,
      /conference\s*ticket/i,
      /workshop\s*ticket/i,
      /event\s*registration/i
    ],

    seatgeek: [
      /seatgeek/i,
      /seatgeek\.com/i,
      /seat\s*geek/i,
      /ticket\s*swap/i,
      /seatgeek\s*swaps/i
    ],

    // Accommodation platforms
    airbnb: [
      /airbnb/i,
      /airbnb\.com/i,
      /air\s*bnb/i,
      /rental/i,
      /host/i,
      /accommodation/i,
      /vacation\s*rental/i,
      /short\s*term\s*rental/i
    ],

    booking: [
      /booking\.com/i,
      /booking/i,
      /hotel\s*booking/i,
      /reservation/i,
      /property\s*booking/i,
      /hotel\s*reservation/i,
      /accommodations/i
    ]
  };

  static detectPlatformFromText(searchText: string): string {
    const lowerSearchText = searchText.toLowerCase();
    
    for (const [platformName, patterns] of Object.entries(this.PLATFORM_PATTERNS)) {
      if (patterns.some(pattern => pattern.test(lowerSearchText))) {
        return platformName;
      }
    }
    return 'unknown';
  }
}
